import { render, staticRenderFns } from "./PatientSearch.vue?vue&type=template&id=22e572cc&scoped=true&"
import script from "./PatientSearch.vue?vue&type=script&lang=js&"
export * from "./PatientSearch.vue?vue&type=script&lang=js&"
import style0 from "./PatientSearch.vue?vue&type=style&index=0&id=22e572cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e572cc",
  null
  
)

export default component.exports